import { contentGroupService } from "fleet/service/content-group";
import { createApiSaga } from "redux-store/api-sagas";

import {
  CREATE_CONTENT_GROUP,
  CREATE_CONTENT_GROUP_ERROR,
  CREATE_CONTENT_GROUP_SUCCESS,
  LOAD_CONTENT_GROUPS,
  LOAD_CONTENT_GROUPS_FAILURE,
  EDIT_CONTENT_GROUP,
  EDIT_CONTENT_GROUP_ERROR,
  EDIT_CONTENT_GROUP_SUCCESS,
} from "./actions";

const reloadContentGroupsSaga = createApiSaga({
  service: contentGroupService.load,
  serviceName: "contentGroupService.load",
  successAction: LOAD_CONTENT_GROUPS,
  failureAction: LOAD_CONTENT_GROUPS_FAILURE,
  reload: true,
});

const editContentGroupSaga = createApiSaga({
  service: contentGroupService.edit,
  serviceName: "contentGroupService.edit",
  fetchAction: EDIT_CONTENT_GROUP,
  successAction: EDIT_CONTENT_GROUP_SUCCESS,
  failureAction: EDIT_CONTENT_GROUP_ERROR,
});

const createContentGroupSaga = createApiSaga({
  service: contentGroupService.new,
  serviceName: "contentGroupService.new",
  fetchAction: CREATE_CONTENT_GROUP,
  successAction: CREATE_CONTENT_GROUP_SUCCESS,
  failureAction: CREATE_CONTENT_GROUP_ERROR,
});

const contentGroupSagas = [
  reloadContentGroupsSaga(),
  createContentGroupSaga(),
  editContentGroupSaga(),
];

export { contentGroupSagas };
